import { ParsedUrlQuery } from 'querystring';
import { GeometryParams } from '../types/SearchQuery/GeometryParams';

const isString = (value: any): value is string => typeof value === 'string' && value !== '';

const hasGeometry = (x: ParsedUrlQuery): x is GeometryParams => (
  isString(x?.nelat)
  && isString(x?.nelon)
  && isString(x?.swlat)
  && isString(x?.swlon)
);

export default hasGeometry;
